import script from "./BannerBajo.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerBajo.vue?vue&type=script&setup=true&lang=js"

import "./BannerBajo.vue?vue&type=style&index=0&id=1ee78b93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee78b93"]])

export default __exports__